// extracted by mini-css-extract-plugin
module.exports = {"Container":"Work_Container__3mv2c"};